export const getEmbedCode = (link?: string) => (`https://www.youtube.com/embed/${(link || '').split('.be/')[1]}`);
